export default __webpack_public_path__ + "static/media/bullsheet_symbol.7210572d.svg";